<template>
    <el-dialog title="Öl-Typ" :visible="value" width="90%" @close="$emit('input', false)">
        <el-form :model="form">
            <el-form-item class="mb-8" label="Öl-Typ">
                <el-input v-model="form.type" autocomplete="off" />
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer u-flex u-flex--space-between">
            <el-button class="u-full-width" type="default" icon="el-icon-close" @click="$emit('input', false)">Abbruch</el-button>
            <el-button
                class="u-full-width"
                type="primary"
                icon="el-icon-check"
                :disabled="!isFormValid"
                :loading="isLoading"
                @click="onSubmit"
            >Speichern</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { omit } from 'ramda'
import Appwrite from '@/assets/appwrite'

export default {
    props: {
        value: { type: Boolean, required: true },
        item: { type: Object, required: true },
    },

    data () {
        return {
            form: omit(['id', 'updated'], this.item),
            isLoading: false,
        }
    },

    watch: {
        item () {
            this.form = omit(['id', 'updated'], this.item)
        },
    },

    computed: {
        isFormValid () {
            return this.form.type
        },
    },

    methods: {
        async onSubmit () {
            if (!this.isFormValid) return

            this.isLoading = true

            try {
                await Appwrite.databases.updateDocument(
                    Appwrite.DB_NAME,
                    'oil_type',
                    this.item.id,
                    this.form,
                )

                this.isLoading = false
                this.$emit('input', false)
                this.$emit('reload')

                this.$notify({
                    title: 'Nice!',
                    message: 'Die Daten wurden gespeichert',
                    type: 'success',
                })
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
                this.isLoading = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    padding-top: $spacing-unit-16;
    padding-bottom: 0;
}
</style>
